
































import "./invite.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import Ajax from "../../lib/ajax";

export default Vue.extend({
  name: "invite-modal",
  components: { UserAvatar },
  props: {
    member: Object,
    show: Boolean,
  },
  data() {
    return {
      users: [],
      userResult: [],
      loading: false,
      inviteModel: {
        memberId: null,
        role: null,
      },
      sending: false,
      rules: {
        memberId: [
          {
            type: "number",
            required: true,
            message: "Please select a user",
            trigger: "blur",
          },
        ],
        role: [
          {
            type: "number",
            required: true,
            message: "Please select a role",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("review", ["currentReview"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("review", ["currentReviewInviteRoles"]),
    showModal: {
      get: function () {
        return (this as any).show;
      },
      set: function (newValue) {
        (this as any).$emit("cancel");
      },
    },
    accountUsers() {
      let context = this as any;
      let members = context.billingAccount && context.billingAccount.members ? context.billingAccount.members.filter((m) => m.licenseAssigned === true) : [];
      if (context.currentReview && context.currentReview.members) {
        members = members.filter((m) => context.currentReview.members.filter((member) => member.memberId === m.memberId).length === 0);
      }

      return members;
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.inviteModel.memberId = null;
        this.inviteModel.role = null;
      }
    },
  },
  mounted() {
    this.loadAccountInfo();
  },
  methods: {
    loadAccountInfo() {
      this.$store
        .dispatch("billing/getBillingAccountInfo")
        .then((response) => {})
        .finally(() => {});
    },
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.InviteForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSend() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      this.sending = true;

      let form = this.$refs.InviteForm as any;
      form.validate((valid: boolean) => {
        if (valid) {
          let reviewId = this.$store.state.review.currentReview.id;
          let context = this;

          this.$store
            .dispatch("review/inviteMember", {
              data: {
                memberId: context.inviteModel.memberId,
                role: context.inviteModel.role,
                reviewId: reviewId,
              },
            })
            .then((response) => {
              context.$store.dispatch("review/get", {
                id: reviewId,
              });
              context.$emit("cancel");
            })
            .finally(() => {
              this.sending = false;
              target.disabled = false;
            });
        } else {
          target.disabled = false;
          this.sending = false;
        }
      });
    },
  },
});
